import styled from 'styled-components';

import Box from 'components/Box';
import { colors } from 'theme';

export const Blockquote = styled(Box)`
  &::before {
    content: '\\201c';
    position: absolute;
    top: 0;
    left: 50%;
    transform: translate(-50%, -35%);
    color: ${colors.marigold};
    font-size: 100px;
    font-weight: 700;
    line-height: 1;
  }
`;
